import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ApplicantMessage } from '@app/models/recruiting/applicant-message.model';
import { AutomatedEmailSettings } from '@app/models/recruiting/automated-email-settings.model';
import { BaseForm } from '@app/modules/forms/base.form';
import { NotifyService } from '@app/services';
import { StoreView } from '@common/views';

@Component({
    templateUrl: './automated-email-settings-store.template.html',
})
export class AutomatedEmailSettingsStoreView extends StoreView {
    isLoading = false;
    applicantMessage = new ApplicantMessage();
    automatedEmailSettings: AutomatedEmailSettings = new AutomatedEmailSettings();

    constructor(
        private router: Router,
        private location: Location,
        private notify: NotifyService
    ) {
        super();
    }

    async onSave(automatedEmailSettingsForm: BaseForm): Promise<void> {
        automatedEmailSettingsForm.submit();

        if (!automatedEmailSettingsForm.valid) {
            return;
        }

        this.isLoading = true;

        try {
            await this.automatedEmailSettings.save();
            this.location.back();
            this.notify.success('applicant-tracker.automaticEmailSettingSaved');
        } catch (err) {
            this.notify.error(err.message);
        }

        this.isLoading = false;
    }

    onCancel(): void {
        this.router.navigate(['/recruiting', 'settings']);
    }
}
